var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lessons-icon_svg__clip0_1693_1431)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lessons-icon_svg__clip1_1693_1431)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.483 2.667a.817.817 0 00-.816.816v13.034c0 .45.365.816.816.816h13.034a.817.817 0 00.816-.816V3.483a.817.817 0 00-.816-.816H3.483zm-2.816.816A2.817 2.817 0 013.483.667h13.034a2.817 2.817 0 012.816 2.816v13.034a2.817 2.817 0 01-2.816 2.816H3.483a2.817 2.817 0 01-2.816-2.816V3.483z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833.667a1 1 0 011 1v16.666a1 1 0 01-2 0V1.667a1 1 0 011-1zM14.167.667a1 1 0 011 1v16.666a1 1 0 01-2 0V1.667a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.667 10a1 1 0 011-1h16.666a1 1 0 110 2H1.667a1 1 0 01-1-1zM.667 5.833a1 1 0 011-1h4.166a1 1 0 110 2H1.667a1 1 0 01-1-1zM.667 14.167a1 1 0 011-1h4.166a1 1 0 110 2H1.667a1 1 0 01-1-1zM13.167 14.167a1 1 0 011-1h4.166a1 1 0 110 2h-4.166a1 1 0 01-1-1zM13.167 5.833a1 1 0 011-1h4.166a1 1 0 110 2h-4.166a1 1 0 01-1-1z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lessons-icon_svg__clip0_1693_1431"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 10 10)",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lessons-icon_svg__clip1_1693_1431"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgLessonsIcon;